// MUI
import { Box } from '@mui/material';

// Custom components
import CustomAccordion from 'components/Accordion/CustomAccordion';
import { ReactNode } from 'react';

const AccordionWrapper = ({
  headerName,
  progress,
  headerEndRenderer,
  children,
  innerSection = false,
  hideBackground = false,
}: {
  headerName: string | ReactNode;
  headerEndRenderer?: ReactNode;
  progress?: { total: number; completed: number };
  score?: { total: number; earned: number; percentage: number };
  children: ReactNode;
  innerSection?: boolean;
  hideBackground?: boolean;
}) => {
  return (
    <CustomAccordion
      showExpandIcon={!innerSection}
      headerProps={{
        sx: {
          backgroundColor: '#EBEAFF !important',
          borderRadiusTop: '0px',
          borderTopRightRadius: '10px',
          borderTopLeftRadius: '10px',
          ...(!innerSection && {
            padding: '0px 24px',
          }),
          ...(innerSection && {
            pointerEvents: 'none',
            borderRadius: '0px',
          }),
          '& .Mui-expanded': {
            padding: '0px',
          },
        },
      }}
      detailProps={{
        sx: {
          ...(!innerSection && {
            padding: '0px 12px 5px 12px',
            backgroundColor: 'rgba(0,0,0,0.04)',
          }),
          '& .MuiBox-root': {
            background: 'transparent',
          },
          ...(hideBackground && {
            padding: '0px 16px',
            backgroundColor: 'white',
          }),
        },
      }}
      header={
        <Box className="d-flex justify-content-between align-items-center w-100">
          <Box
            className="header-title"
            sx={{
              color: 'rgba(33,33,33,1)',
              fontWeight: '700',
              fontSize: '16px',
            }}
          >
            {headerName}{' '}
            {progress ? `(${progress.completed} of ${progress.total})` : null}
          </Box>
          {headerEndRenderer ?? null}
        </Box>
      }
    >
      {children}
    </CustomAccordion>
  );
};

export default AccordionWrapper;
